import { Component, Input } from '@angular/core';
import { CustomerCampaignService } from '../../../../services/customer-campaign.service';
import { KeywordConfig } from '../../../../shared/models/keywords/keywords';

@Component({
  selector: 'app-components-shared-page',
  templateUrl: './page.component.html',
  styleUrls: ['../customer-campaign/customer-campaign.component.scss']
})
export class PageComponent {
  @Input() customer: Boo.Objects.Customer;
  @Input() websiteUrl: Boo.Objects.WebsiteUrl;
  @Input() websiteUrls: Boo.Objects.WebsiteUrl[];
  @Input() trackingKeywords: Boo.Objects.WebsiteKeywordTracking[];
  @Input() archivedWebsiteUrls: Boo.Objects.ArchivedWebsiteUrl[];
  @Input() archivedKeywords: Boo.Objects.ArchivedKeyword[];
  @Input() readOnlyReasons: string;
  @Input() firstPageKeywordPhrases: string[];
  @Input() restrictions: Boo.Objects.CustomerCampaign.Enums.RestrictionTypes[];
  @Input() reviewSource: Boo.OnsiteRecommendations.Models.Enums.ReviewSources;
  @Input() keywordConfig: KeywordConfig;

  isUrlReadOnly: boolean;

  constructor(private customerCampaignService: CustomerCampaignService) { }

  get allReadOnlyReasons(): string {
    let allReadOnlyReasons = '';

    if (this.restrictions.includes(Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.ReadOnly)) {
      allReadOnlyReasons = this.readOnlyReasons;
    }

    if (this.websiteUrl?.IsReadOnly) {
      allReadOnlyReasons = [allReadOnlyReasons, this.websiteUrl.ReadOnlyReason].filter(Boolean).join(', ').trim();
    }

    return allReadOnlyReasons;
  }

  get validationMessages(): string[] {
    const messages: string[] = [];

    if (this.customerCampaignService.isActiveStatus(this.websiteUrl) && !this.customerCampaignService.domainMatches(this.customer.Url, this.websiteUrl.Url)) {
      messages.push('The page domain must match the customer domain.');
    }

    if (this.websiteUrls.some(websiteUrl => websiteUrl.WebsiteUrlId != this.websiteUrl.WebsiteUrlId && this.customerCampaignService.isActiveStatus(websiteUrl) && websiteUrl.Url.toLowerCase().trim() === this.websiteUrl.Url.toLowerCase().trim())) {
      messages.push('Duplicate');
    }

    if (this.websiteUrl.StatusId === Boo.Objects.Enums.WebsiteUrlStatuses.Target && this.websiteUrl.Keywords.filter(keyword => keyword.IsActive).length === 0) {
      messages.push('Target pages must have at least one keyword.');
    }

    if (this.websiteUrl.StatusId === Boo.Objects.Enums.WebsiteUrlStatuses.New && this.websiteUrl.Keywords.filter(keyword => keyword.IsActive).length === 0) {
      messages.push('New pages must have at least one keyword.');
    }

    return messages;
  }
}
